import { bootstrapApplication } from '@angular/platform-browser';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import './app/core/extensions/methods/array-extension';
import './app/core/extensions/methods/string-extension';

bootstrapApplication(AppComponent, appConfig)
  .then(() => {
    if ('serviceWorker' in navigator)
      navigator.serviceWorker.register('/ngsw-worker.js');
  })
  .catch((err) => console.error(err));
